var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { C } from "../enums-86f58524.js";
import { Schema, required, type } from "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class ComponentDataSchema extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "type");
    __publicField(this, "data");
    __publicField(this, "inherit");
  }
}
__decorateClass([
  required(),
  type("string")
], ComponentDataSchema.prototype, "type", 2);
__decorateClass([
  type("object")
], ComponentDataSchema.prototype, "data", 2);
__decorateClass([
  type("boolean")
], ComponentDataSchema.prototype, "inherit", 2);
export {
  C as ComponentCategory,
  ComponentDataSchema
};
//# sourceMappingURL=types.js.map
